import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';
import * as React from 'react';
import { ProjectGq, ProjectGqProps } from '../../models/ProjectGq';
import { ProjectTypeGq } from '../../models/ProjectTypeGq';

export default function useUpdateProjectGq() {
  const [mutation, mutationResult] = useMutation<GqResponse, GqVariables>(gqTag);

  return React.useCallback(
    (command: GqProjectUpdateCommand) =>
      mutation({ variables: { command } }).then((result) => result.data.projects.update.project),
    []
  );
}

const gqTag = gql`
  mutation ProjectsUpdate($command: ProjectUpdateCommand!) {
    projects {
      update(command: $command) {
        project { ${ProjectGqProps} }
      }
    }
  }
`;

interface GqVariables {
  command: GqProjectUpdateCommand;
}

export interface GqProjectUpdateCommand {
  id: number;
  type?: ProjectTypeGq;
  name?: string;
  clientName?: string;
  negativeTerms?: string;
  currency: string;
  defaultLanguageId?: number;
  defaultLanguageName?: string;
  defaultLocationId?: number;
  defaultLocationName?: string;
  defaultMinSearchVolume: number;
  defaultIncludeMonths: boolean;
  createIntialTagGroup?: boolean;
}

interface GqResponse {
  projects: {
    update: {
      project: ProjectGq;
    };
  };
}
